import { render, staticRenderFns } from "./UniqueActiveCustomersPerMonth.vue?vue&type=template&id=2bc9ec6b"
import script from "./UniqueActiveCustomersPerMonth.vue?vue&type=script&lang=js"
export * from "./UniqueActiveCustomersPerMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports